import React, { useEffect, useCallback, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getDetailLivraison,
  getLivraisonById,
} from "../../Redux/livraisonReduce";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
function DetailsLivraison({ client }) {
  const dispatch = useDispatch();
  const location = useParams();
  var idLivraison = location.id;
  var id = location.id;
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);

  //input
  const [data, setData] = React.useState([]);
  const [livraison, setLivraison] = React.useState({});
  const [loader, setLoader] = React.useState(true);

  /* detailLivraison */
  const detailLivraison = useCallback(async (idLivraison) => {
    var det = await dispatch(getDetailLivraison(idLivraison));
    var dataD = await det.payload;
    setData(dataD)
    setLoader(false)
    var dataLivraison = await dispatch(getLivraisonById(idLivraison));
    var livraisonD = await dataLivraison.payload;
    setLivraison(livraisonD);
  }, [dispatch, idLivraison]);




  useEffect(() => {
    detailLivraison(idLivraison)
  }, [idLivraison, id]);



  return (
    <>

      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        ""
      )}
      {!loader ? (
        <Container fluid>
          <ToastContainer />
          <div className="section-image">
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={() => {
                    window.history.back();
                  }}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  {t('list')}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">{t("livraison_details")}</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <div>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>{t("No_livraison")}</th>
                              <th>Code {t("Wholesaler")}</th>
                              <th>{t("Wholesaler")}</th>
                              <th>{t("Date_livraison")}</th>
                              <th>{t("Valide")}</th>
                              <th>{t("Facture")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{livraison.NumLivraison}</td>
                              <td>{livraison.Client}</td>
                              <td>{livraison?.RaisonSocial}</td>
                              <td>{livraison.DateLivraison}</td>
                              <td>{livraison.Valide == 1 ? "Non" : "Oui"}</td>
                              <td>{livraison.Facture == 1 ? "Non" : "Oui"}</td>
                            </tr>
                          </tbody>
                        </table>
                        <hr></hr>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>{t("No_livraison")}</th>
                              <th>{t("No_commande")}</th>
                              <th>{t("code_article")}</th>
                              <th>{t("designation")}</th>
                              <th>{t("qte")}</th>
                              <th>{t("Lot")}</th>
                              <th>{t("Date expiration")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((e) => {
                              return (
                                <tr key={"ligne-" + e.id}>
                                  <td>{e.NumLivraison}</td>
                                  <td>{e.NumCommande}</td>
                                  <td>{e.CodeArticle}</td>
                                  <td>{e.DesignationArticle}</td>
                                  <td>{e.Quantite}</td>
                                  <td>
                                    {e.LOT}
                                  </td>
                                  <td>{e.DateExpiration}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      ) : (
        ""
      )}
    </>
  );
}

export default DetailsLivraison;
